export const SUBSCRIPTIONS = "Subscriptions";
export const REWARDS = "Rewards";

export const CA_MARKET = "CA";

export const US_MARKET = "US";

export const ITEM_HEIGHT = 44;

export const PRODUCT_UNAVAILABLE_URL = "/_ui/desktop/common/assets-doterra/images/prod-unavailable.png";

export const SUBSCRIPTION_ACTION = {
    SET_SUBSCRIPTION: "SET_SUBSCRIPTION"
};
export const ICON_SIZE = {
    TINY: "tiny",
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large",
    EXTRA_LARGE: "extraLarge"
};

export const SLICK_CONFIG = {
    className: "nav nav-tabs",
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    variableWidth: true,
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                variableWidth: false
            }
        }
    ]
};